import Head from "../../layout/Head";
import Footer from "../Shear/Footer/Footer";
import Header from "../Shear/Header/Header";
import ScrollToTop from "../Shear/ScrollToTop";

const PrivacyPolicy = (props) => {
  return (
    <>
      <Head
        Title="Privacy Policy"
        href="/privacy-policy"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Contact Pages"
      />
      <Header />

      <div className="bg-gray-100">
        <section className="container mx-auto p-6 font-sans">
          <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
          <p className="mb-6">Effective Date: December 24, 2023</p>
          {/* Introduction section */}
          <h2 className="text-xl font-bold mb-4">Introduction</h2>
          <p className="mb-6">
            Welcome to WebNex-IT ("we," "our," or "us"). At WebNex-IT, we are
            committed to protecting your privacy and ensuring the security of
            your personal information. This Privacy Policy outlines our
            practices regarding the collection, use, and disclosure of your
            personal data when you use our website, www.webnexit.com, and our
            related services.
          </p>
          <p className="mb-6">
            By using our website and services, you agree to the terms of this
            Privacy Policy. If you do not agree with the terms herein, please do
            not use our website or services.
          </p>
          <h3 className="text-xl font-bold mb-4">Information We Collect</h3>
          <p className="mb-6">
            We collect and process various types of information to provide and
            improve our services. The types of information we may collect
            include:
          </p>
          <h3 className="text-xl font-bold mb-4">2.1 Personal Information:</h3>
          <p className="mb-6">
            Contact information such as your name, email address, and phone
            number. Billing information for purchases, including credit card
            details. Any other information you choose to provide voluntarily.
          </p>
          <h3 className="text-xl font-bold mb-4">
            2.2 Automatically Collected Information:
          </h3>
          <p className="mb-6">
            Log data, including your IP address, browser type, operating system,
            and access times. Information is collected via cookies and similar
            technologies. How We Use Your Information We use the collected
            information for the following purposes:
          </p>
          <h3 className="text-xl font-bold mb-4">3.1 Providing Services:</h3>
          <p className="mb-6">
            Processing and fulfilling your orders for freelancing courses,
            websites, design, development, and other IT services. Managing your
            account and providing customer support.
          </p>
          <h3 className="text-xl font-bold mb-4">3.2 Communication:</h3>
          <p className="mb-6">
            Sending you important updates, newsletters, and promotional
            materials. Responding to your inquiries and providing information
            about our services.
          </p>
          <h3 className="text-xl font-bold mb-4">3.3 Legal Compliance:</h3>
          <p className="mb-6">
            Complying with legal obligations and resolving disputes. Data
            Security We take appropriate measures to protect your personal
            information from unauthorized access, disclosure, alteration, and
            destruction. These measures include encryption, secure data storage,
            and restricted access to personal information. Disclosure of
            Personal Information We may share your personal information with
            third parties in the following circumstances:
          </p>

          <h3 className="text-xl font-bold mb-4">5.1 Service Providers:</h3>
          <p className="mb-6">
            We may engage third-party service providers to assist us in
            providing and improving our services.
          </p>
          <h3 className="text-xl font-bold mb-4">5.2 Legal Compliance:</h3>
          <p className="mb-6">
            We may disclose personal information as required by law or to
            protect our rights and comply with legal processes.
          </p>
          <h3 className="text-xl font-bold mb-4">5.3 Business Transactions:</h3>
          <p className="mb-6">
            In the event of a merger, acquisition, or sale of all or part of our
            assets, your personal information may be transferred as part of the
            transaction. Your Rights You have the right to access, correct, or
            delete your personal information. If you wish to exercise these
            rights or have any questions about our privacy practices, please
            contact us at infoitghor24@gmail.com.
          </p>
          <h3 className="text-xl font-bold mb-4">
            Changes to the Privacy Policy
          </h3>
          <p className="mb-6">
            We reserve the right to update this Privacy Policy to reflect
            changes in our practices and services. The updated Privacy Policy
            will be effective upon posting on our website.
          </p>

          <h2 className="text-xl font-bold mb-4">Contact Information</h2>
          <p className="mb-6">
            If you have any questions or concerns about this Privacy Policy,
            please contact us at:
          </p>
          <p className="mb-8">
            WebNex-IT
            <br />
            Bornomala High School Road (Beside Donia College)
            <br />
            Nayapara, Jatrabari, Dhaka - 1236
            <br />
            Email: infoitghor24@gmail.com
          </p>
          <p className="text-center">
            Thank you for trusting WebNex-IT with your personal information.
          </p>
        </section>
      </div>
      <ScrollToTop />
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
